import "./dispatch-error-modal.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { alertTriangle } from "@tql/ui-components-react/untitled/icons";
import { format } from "date-fns";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

export const DispatchErrorModal = ({
	onClose,
	isOpen,
	attemptedAt,
	errorMessage,
}: {
	onClose: () => void;
	isOpen: boolean;
	attemptedAt: Date | null;
	errorMessage: string | null | undefined;
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			className={"dispatch-error-modal"}
			confirmText={"I understand"}
			confirmVariant={"danger"}
			onClose={onClose}
			onConfirm={onClose}
			showCancelButton={false}
			showConfirmationButtons={true}
			title={"Dispatch Error"}
			type={"error"}
			width={346}
		>
			<div className={"dispatch-error-content"}>
				<SvgIcon className={"dispatch-error-icon"} icon={alertTriangle} />
				<div className={"dispatch-error-text"}>
					<p>
						Dispatch could not be completed.
						<br />
						Attempted on{" "}
						{attemptedAt ? format(attemptedAt, "M/d/yyyy, h:mm a") : "N/A"}
					</p>
					<p>
						Error:
						<br />
						{errorMessage ?? "N/A"}
					</p>
				</div>
			</div>
		</TraxModal>
	);
};
